import React from "react";
import { Button, Dimmer, Header, Icon, Loader, Form, Modal } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import ProcessingImageStore from "~/stores/ProcessingImageStore";
import ProcessingImageFilter from "./ProcessingImageFilter";
import "./styles/ProcessingImageModal.less";
import FlashMessage from "./FlashMessage";

@observer
class ProcessingImageModal extends React.Component {
  render() {
    const { processingImageStore } = this.props;
    const {
      filterConfiguration,
      isLoading,
      isImageLoading,
      currentImageIndex,
      hasChanges,
      numberOfImages,
      currentImageUrl,
    } = processingImageStore;

    return (
      <Modal
        className="processingImageModal"
        size="large"
        open={processingImageStore.showModal}
        onClose={() => {
          processingImageStore.showModal = false;
        }}
      >
        <Modal.Header>Edit image</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            <Header>Settings</Header>
            <Form>
              {filterConfiguration.map(filter => (
                <ProcessingImageFilter
                  key={filter.id}
                  processingImageStore={processingImageStore}
                  filterName={filter.name}
                  filterMinValue={filter.minValue}
                  filterMaxValue={filter.maxValue}
                />
              ))}
            </Form>
            <Button
              className="revertChangesButton"
              basic
              fluid
              color="red"
              size="mini"
              title="Revert changes"
              disabled={isLoading || !hasChanges}
              onClick={() => processingImageStore.revertCanvas()}
            >
              <Icon name="undo" /> Revert changes
            </Button>
          </Modal.Description>
          <div className="ui huge image" style={{ minHeight: "400px" }}>
            <Dimmer active={isLoading} inverted>
              <Loader size="mini">Loading</Loader>
            </Dimmer>
            <img
              id="canvas"
              src={currentImageUrl}
              style={isImageLoading ? { display: "none" } : {}}
              onLoad={() => processingImageStore.finishImageLoading()}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <FlashMessage flashMessageStore={processingImageStore.flashMessageStore} />
          {numberOfImages > 1 ? (
            <>
              <Button
                secondary
                disabled={isLoading || currentImageIndex === 0}
                onClick={() => processingImageStore.changeCurrentImage(currentImageIndex - 1)}
              >
                Previous
              </Button>
              <Button
                secondary
                disabled={isLoading || currentImageIndex === numberOfImages - 1}
                onClick={() => processingImageStore.changeCurrentImage(currentImageIndex + 1)}
              >
                Next
              </Button>
            </>
          ) : null}
          <Button
            primary
            disabled={isLoading || !hasChanges}
            onClick={() => processingImageStore.updateUploadedImage()}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

ProcessingImageModal.propTypes = {
  processingImageStore: PropTypes.instanceOf(ProcessingImageStore),
};

export default ProcessingImageModal;
